<template>
  <section class="layout-cta -bottom">
    <RouterLink v-scroll:reveal :to="{ name: 'donation' }" class="layout-cta__box -accent">
      <BranchShape v-scroll:reveal="{ delay: 125 }" class="layout-cta__branch" color="white" opacity="0.1" />

      <div v-scroll:reveal="{ delay: 75 }" class="layout-cta__content">
        <h4 class="layout-section__heading">{{ $wp.pages.home.cta.title }}</h4>
        <p>
          {{ $wp.pages.home.cta.text }}
        </p>
      </div>

      <button v-scroll:reveal="{ delay: 175 }" class="layout-cta__button">
        <SvgIcon id="action-arrow" />
      </button>
    </RouterLink>
  </section>
</template>

<script>
export default {
  name: 'NavigationCta'
}
</script>
